import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

import { SvgIcon } from '~/elements/SvgIcon'

import { SearchOperations } from '../constants'

const iconNames: Record<SearchOperations, string> = {
  [SearchOperations.Equals]: 'equals',
  [SearchOperations.NotEquals]: 'not_equals',
  [SearchOperations.Less]: 'less',
  [SearchOperations.LessOrEqual]: 'less_or_equals',
  [SearchOperations.Greater]: 'greater',
  [SearchOperations.GreaterOrEqual]: 'greater_or_equals',
  [SearchOperations.Contains]: 'contains',
  [SearchOperations.StartsWith]: 'starts_with',
  [SearchOperations.EndsWith]: 'ends_with'
  // [SearchOperations.Exists]: 'question_mark',
  // [SearchOperations.Type]: 'question_mark'
  // [SearchOperations.In]: '=~',
  // [SearchOperations.NotIn]: '!=~'
}

const operationIcon = cva('grid h-5 w-5 place-items-center rounded-md', {
  variants: {
    variant: {
      filled:
        'grid h-5 w-5 place-items-center rounded-md bg-gradient-to-br from-accent/10 to-accent-hover/30 text-accent h-5 w-5 [&>svg]:w-4 [&>svg]:h-4',
      normal: 'contents [&_svg]:w-4 [&>svg]:h-4'
    }
  },
  defaultVariants: {
    variant: 'normal'
  }
})

export function SearchOperationIcon({
  operation,
  className,
  variant,
  size
}: {
  className?: string
  operation: SearchOperations
  size?: number
} & VariantProps<typeof operationIcon>) {
  if (!operation) {
    return null
  }

  return (
    <div className={operationIcon({ className, variant })}>
      <SvgIcon height={size} name={iconNames[operation]} width={size} />
    </div>
  )
}
